import React from "react";

type RecordingStopProgressIconProps = React.SVGProps<SVGSVGElement> & {
  radius: number;
  strokeWidth: number;
  circumference: number;
  progressOffset: number;
};

export const CreatorRecordingStopProgressIcon = ({
  radius,
  strokeWidth,
  circumference,
  progressOffset,
  ...props
}: RecordingStopProgressIconProps) => (
  <svg width="120" height="120" viewBox="0 0 120 120" {...props}>
    <circle
      cx="60"
      cy="60"
      r={radius}
      stroke="#fff"
      strokeWidth={strokeWidth}
      fill="none"
    />
    <circle
      cx="60"
      cy="60"
      r={radius}
      stroke="#03f"
      strokeWidth={strokeWidth}
      fill="none"
      strokeDasharray={circumference}
      strokeDashoffset={progressOffset}
      strokeLinecap="round"
      transform="rotate(-90 60 60)"
      style={{ transition: "stroke-dashoffset 0.5s linear" }}
    />
    <rect
      x="33%"
      y="33%"
      width="40"
      height="40"
      rx="3"
      fill="#03f"
      opacity="0.75"
    />
  </svg>
);

export const CreatorTextFontToolIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.477"
    height="24"
    viewBox="0 0 24.477 24"
    {...props}
  >
    <path
      d="M18.987,7.5v20.4h-3.5V7.5H5V4H29.477V7.5Z"
      transform="translate(-5 -4)"
      fill="#fff"
    />
    <path
      d="M10.547,5.387v8.088H9.16V5.387H5V4h9.707V5.387Z"
      transform="translate(9.293 10.418)"
      fill="#fff"
    />
  </svg>
);

export const CreatorTextColorToolIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.4"
    height="24"
    viewBox="0 0 22.4 24"
    {...props}
  >
    <path
      d="M21.92,20.6H11.533L8.973,27H5.526l9.6-24h3.2l9.6,24H24.48Zm-1.28-3.2L16.726,7.616,12.813,17.4Z"
      transform="translate(-5.526 -3)"
      fill="#fff"
    />
  </svg>
);
